export const ProductColumn = () => [
  {
    title: 'Nume',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Descriere',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Categorie',
    dataIndex: 'category',
    key: 'category',
  },
  {
    title: 'Pret',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: 'Stoc',
    dataIndex: 'stock',
    key: 'stock',
  },
  {
    title: 'In stoc',
    dataIndex: 'isInStock',
    key: 'isInStock',
  },
  {
    title: 'Vanzator',
    dataIndex: 'seller',
    key: 'seller',
  },
  {
    title: 'Link',
    dataIndex: 'url',
    key: 'url',
  },
  // {
  //   title: 'Manufacturer',
  //   dataIndex: 'manufacturer',
  //   key: 'manufacturer',
  // },
  // {
  //   title: 'Version',
  //   dataIndex: 'version',
  //   key: 'version',
  // },
  // {
  //   title: 'ProductId',
  //   dataIndex: 'product_Id',
  //   key: 'id',
  // },
  // {
  //   title: 'Category Id',
  //   dataIndex: 'category_Id',
  //   key: 'category_Id',
  // },
];
